/**
 * Dấu hiệu "trình duyệt này đang có phiên đăng nhập admin", lưu ở localStorage.
 *
 * Trang công khai đọc nó để quyết định CÓ NẠP lớp chỉnh sửa hay không, mà không
 * phải kéo Firebase Auth vào bundle chính (xem InlineEditProvider). Đây chỉ là
 * gợi ý cho UI: quyền thật vẫn do Firebase Auth và database.rules.json quyết
 * định — sửa tay giá trị này chỉ khiến trình duyệt tải thừa một chunk, không
 * ghi được gì lên cơ sở dữ liệu.
 */

const KEY = 'btt:admin-session';

export const hasAdminHint = () => {
    try {
        return window.localStorage.getItem(KEY) === '1';
    } catch (error) {
        return false; // Safari ở chế độ riêng tư chặn localStorage
    }
};

export const setAdminHint = (on) => {
    try {
        if (on) window.localStorage.setItem(KEY, '1');
        else window.localStorage.removeItem(KEY);
    } catch (error) {
        // Không lưu được thì admin vẫn vào /admin như cũ, chỉ mất tiện lợi.
    }
};
